import { render } from "./video_chart.vue?vue&type=template&id=987b7954&scoped=true"
import script from "./video_chart.vue?vue&type=script&lang=js"
export * from "./video_chart.vue?vue&type=script&lang=js"

import "./video_chart.vue?vue&type=style&index=0&id=987b7954&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境/M平台/前端/servicepartner.matchupexpo.com - 外呼合作方端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987b7954"]])

export default __exports__